var _regeneratorRuntime = require("/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _require = require('./datafile'),
    resolveDatafile = _require.resolveDatafile;

function fireImpression(_x, _x2, _x3) {
  return _fireImpression.apply(this, arguments);
}

function _fireImpression() {
  _fireImpression = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(experimentKey, variationKey, sdkKey) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(!isValid(experimentKey) || !isValid(variationKey) || !isValid(sdkKey))) {
              _context.next = 3;
              break;
            }

            console.error('ab-impression not well defined input parameter for the fireImpression method');
            return _context.abrupt("return", false);

          case 3:
            _context.prev = 3;
            _context.next = 6;
            return trackExperimentViewed(experimentKey, variationKey, sdkKey);

          case 6:
            return _context.abrupt("return", true);

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](3);
            console.error("Error sending impression: ".concat(_context.t0));
            return _context.abrupt("return", false);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 9]]);
  }));
  return _fireImpression.apply(this, arguments);
}

function isValid(input) {
  return input !== undefined && input !== '' && input !== null;
}

function trackExperimentViewed(_x4, _x5, _x6) {
  return _trackExperimentViewed.apply(this, arguments);
}

function _trackExperimentViewed() {
  _trackExperimentViewed = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(experimentKey, variationKey, sdkKey) {
    var experimentIdStr, variationIdStr, datafile, experiment, variation, trackProperties, sendTrackEvent;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            sendTrackEvent = function _sendTrackEvent(props) {
              // https://app.segment.com/vistaprint/protocols/tracking-plans/rs_1Uvr60Jg3ROZK4boO6jKvuUj2du
              window.tracking.track('Experiment Viewed', props);
            };

            experimentIdStr = undefined;
            variationIdStr = undefined;
            datafile = undefined;
            _context2.prev = 4;
            _context2.next = 7;
            return resolveDatafile(sdkKey);

          case 7:
            datafile = _context2.sent;
            _context2.next = 13;
            break;

          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](4);
            console.error("Error getting datafile: ".concat(_context2.t0));

          case 13:
            if (!datafile) {
              _context2.next = 22;
              break;
            }

            experiment = datafile.experiments.find(function (e) {
              return e.key === experimentKey;
            });

            if (experiment) {
              _context2.next = 17;
              break;
            }

            throw new Error("Experiment ".concat(experimentKey, " not active in ").concat(sdkKey, "."));

          case 17:
            experimentIdStr = experiment.id ? experiment.id.toString() : undefined;
            variation = experiment.variations.find(function (v) {
              return v.key === variationKey;
            });

            if (variation) {
              _context2.next = 21;
              break;
            }

            throw new Error("Experiment ".concat(experimentKey, " does not have variation ").concat(variationKey));

          case 21:
            variationIdStr = variation.id ? variation.id.toString() : undefined;

          case 22:
            trackProperties = {
              experimentName: experimentKey,
              variationName: variationKey,
              experimentId: experimentIdStr,
              variationId: variationIdStr,
              nonInteraction: 1,
              // To be able to populate GA session and user scope custom dimensions with experiment and variation id
              experimentIdSession: experimentIdStr,
              variationIdSession: variationIdStr,
              experimentIdUser: experimentIdStr,
              variationIdUser: variationIdStr,
              optimizelySdkKey: sdkKey,
              impressionEventVersion: 2
            };

            if (window && window.tracking && window.tracking.track) {
              sendTrackEvent(trackProperties);
            } else {
              window.addEventListener('trackingReady', function () {
                sendTrackEvent(trackProperties);
              });
            }

          case 24:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[4, 10]]);
  }));
  return _trackExperimentViewed.apply(this, arguments);
}

module.exports.fireImpression = fireImpression;